import { Icon, Modal, Typography } from "@/components/atoms";

interface FleetLeaderModalProps {
  open: boolean;
  onClose: () => void;
}

export const FleetLeaderModal = ({ open, onClose }: FleetLeaderModalProps) => {
  const renderHeader = () => (
    <div className="flex flex-row items-center">
      <Typography variant="title" className="flex-1">
        What&apos;s a Fleet Leader?
      </Typography>
      <Icon name="close" isCustom className="flex cursor-pointer justify-end" onClick={onClose} />
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[514px] lg:w-[514px]">
      {renderHeader()}
      <div className="mt-3 flex flex-col items-center justify-center rounded-lg bg-neutral-gray p-5">
        <div className="rounded-full border-4 border-success p-1">
          <div className="flex h-[54px] w-[54px] items-end justify-center rounded-full bg-neutral-mid-gray">
            <Icon name="Profile" size={48} variant="Bold" className="text-neutral-dark-gray" />
          </div>
        </div>
        <Typography variant="small" className="mt-2.5 text-center text-neutral-dark-gray">
          A green circle around the profile picture identifies a fleet leader.
        </Typography>
      </div>
      <Typography variant="paragraph" className="mt-6">
        Fleet leaders are defined by operators and have an elevated set of permissions. By being a fleet leader they are able to:
        <br />
        1. Reassign jobs to other drivers (via the driver app)
        <br />
        2. Be assigned jobs through the private network
        <br />
        3. Are visible to operators when searching in the Driver Manager
        <br />
      </Typography>
    </Modal>
  );
};
